import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from "@mui/material";
import { hideDialog } from "../../base/dialog/actions";
import SearchParticipantToPin from "../components/SearchParticipantToPin";
import Dialog from "../../base/ui/components/web/Dialog";
import { sendCommand } from '../../mod-command/slice';
import { COMMANDS } from '../../mod-command/constants';
import { getPinnedActiveParticipants } from '../../filmstrip/functions.web';
import { removeStageParticipant } from '../../filmstrip/actions.web';
import useDialogPinParticipant from '../hookss/useDialogPinParticipant';
const DialogPinParticipant = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { component } = useSelector((state) => state['features/base/dialog']);
    const { local, remoteFilter, tmpPinId, setTmpPinId, valueFilter, setValueFilter, _sortedRemoteScreenshares, localScreenShare } = useDialogPinParticipant();
    const closeModal = () => dispatch(hideDialog(component));
    const handlePinnedParticipant = (id) => {
        // dispatch(setFollowMe(true))
        // dispatch(setIsPinnedParticipant(true))
        // dispatch(pinParticipant(id ? id : null));
        const state = APP.store.getState();
        const pinnedParticipants = getPinnedActiveParticipants(state);
        const findPinnedParticipant = pinnedParticipants.find((p) => p.participantId === id);
        if (id) {
            if (findPinnedParticipant) {
            }
            else {
                dispatch(sendCommand(COMMANDS.PIN_PARTICIPANT.COMMAND, id, true));
            }
        }
        else {
            dispatch(removeStageParticipant(pinnedParticipants[0]?.participantId));
            dispatch(sendCommand(COMMANDS.UN_PIN_PARTICIPANT.COMMAND, pinnedParticipants[0]?.participantId, true));
        }
        closeModal();
    };
    return (React.createElement("div", null, component && (React.createElement(Dialog, { title: React.createElement(Typography, { fontWeight: 700, fontSize: 20 }, t('menuController.pinnedForAll')), ok: { translationKey: 'menuController.save' }, onSubmit: () => handlePinnedParticipant(tmpPinId), size: 'medium-large' },
        React.createElement("div", { style: { paddingTop: 0, paddingBottom: 12 } },
            React.createElement("div", { className: "desc-search-pin" }, t('menuController.pinnedDesc')),
            React.createElement(SearchParticipantToPin, { handlePinnedParticipant: handlePinnedParticipant, closeModal: closeModal, local: local, remoteFilter: remoteFilter, tmpPinId: tmpPinId, setTmpPinId: setTmpPinId, valueFilter: valueFilter, setValueFilter: setValueFilter, _sortedRemoteScreenshares: _sortedRemoteScreenshares, localScreenShare: localScreenShare }))))));
};
export default DialogPinParticipant;
